import styled from "styled-components";

import { T_PLAIN_big } from "../../global.style";


export const BackgroundJobResultsWrapper = styled.div`
    display: block;
    width: 100%;
    ${T_PLAIN_big};
`;

export const GeneralErrorWrapper = styled.div`
    display: flex;
    align-items: center;
    ${T_PLAIN_big};
`;

export const BackgroundJobGroupButtons = styled.div`
    margin-bottom: 15px;
    margin-top: 30px;
`;

export const BackgroundJobTableWrapper = styled.div <{
    $useVirtualizations: boolean;
}>`
    width: 100%;
    height: ${props => props.$useVirtualizations ? "800px" : "auto"};
`;

export const StyledBackgroundJobParameters = styled.div`
    ${T_PLAIN_big};
`;

export const GeneralErrorInfo = styled.div`
    margin-left: 10px;
`;
